var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaceGood = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16.29,
  cy: 16,
  r: 16,
  fill: "#1F9974"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.936 13.47a1.386 1.386 0 0 1-.363-.934c0-.784.66-1.42 1.476-1.42.58 0 1.081.322 1.323.79a1.482 1.482 0 0 1 1.323-.79c.814 0 1.475.636 1.475 1.42 0 .357-.137.684-.362.933l-1.65 2.1a1 1 0 0 1-1.573 0l-1.649-2.099ZM7.773 13.47a1.386 1.386 0 0 1-.363-.934c0-.784.66-1.42 1.476-1.42.58 0 1.081.322 1.323.79a1.482 1.482 0 0 1 1.322-.79c.815 0 1.476.636 1.476 1.42 0 .357-.137.684-.362.933l-1.65 2.1a1 1 0 0 1-1.573 0L7.773 13.47Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.573 19.814c0 2.132-1.47 3.86-3.283 3.86s-3.283-1.728-3.283-3.86",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgFaceGood;